<template>
  <div>
    <template v-if="template === 'edit' || typeof template === 'undefined'">
        <label :class="labelClass ? labelClass : 'u-label'">
          {{ field.label + (field.required ? '* ' : '') }}
        </label>
        <input
          v-if       = "!field.readonly"
          :class     = "'qa-' +field.name + '__input'"
          :value     = "value"
          :maxlength = "maxlength"
          @input     = "update($event.target.value)"
          type       = "text"
        />
        <input
          v-if       = "field.readonly"
          :class     = "'qa-' +field.name + '__input'"
          :value     = "value"
          :maxlength = "maxlength"
          type       = "text"
          readonly   = "readonly"
          disabled   = "disabled"
        />
    </template>
    <template v-if="template === 'detail'">
        <label :class="labelClass ? labelClass : 'u-label'">
          {{ field.label + (field.required ? '* ' : '') }}
        </label>
        <p
          class  = "u-paragraph"
          :class = "'qa-' + field.name + '__value'"
        >
          {{ value }}
        </p>
    </template>
  </div>
</template>


<script>
export default {
  props: ['field', 'value', 'labelClass', 'template'],
  computed: {
    maxlength: function () {
      return (this.field.maxlength ? this.field.maxlength : 255)
    }
  },
  methods: {
    update (value) {
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// FieldVarchar.vue?bb155c0c